import { Spinner } from "@fluentui/react-components";

export function Loading({ label }: { label: string }) {
  return (
    <div style={{ display: "flex", justifyContent: "center", padding: "3rem 0" }}>
      <Spinner label={label} />
    </div>
  );
}
